import React from 'react'
import StatementProviders from './Providers'
import StatementChild from './StatementChild'
export default () => <StatementProviders> <StatementChild /> </StatementProviders>
